import dayjs from "dayjs"
import { useUserSettings } from "api/hooks"
import utc from "dayjs/plugin/utc"
dayjs.extend(utc)

const DateSecond = ({ value }) => {
  const { data: userSettings } = useUserSettings()

  if (!value) return null

  const dateValue = () => {
    if (userSettings?.date_format) {
      return dayjs.utc(value).local().format(`${userSettings.date_format} HH:mm:ss`)
    }
    return dayjs.utc(value).local().format("MM/DD/YYYY HH:mm:ss")
  }

  return <div style={{ whiteSpace: "nowrap" }}>{dateValue()}</div>
}

export default DateSecond
